export const API = process.env.REACT_APP_CMS
export const CMS = process.env.REACT_APP_CMS
export const DOMAIN = process.env.REACT_APP_DOMAIN
export const TOKEN = process.env.REACT_APP_TOKEN
export const VARIANTE = 'code'
